import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, HorizontalFormControl, Modal } from '../../../../common/components';
import { closeModal, openModal } from '../../../../common/components/Modal/ModalRedux';
import { sendSms } from '../../redux/policyActions';
import { get, set } from 'lodash';

const FORM_NAME = 'sendSmsForm';

const validate = (values) => {
  const errors = {};

  if (!get(values, 'meta.number')) {
    set(errors, 'meta.number', 'Phone number is required');
  }

  return errors;
};

class SendSmsButton extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    resource: PropTypes.object.isRequired,
    phoneNumber: PropTypes.string,
    callback: PropTypes.func,
    label: PropTypes.string,
  };

  componentWillUpdate(newProps) {
    const { dispatch, submitSucceeded, callback } = this.props;
    if (newProps.submitSucceeded && !submitSucceeded) {
      if (callback) {
        callback('');
      }
      dispatch(closeModal(FORM_NAME));
    }
  }

  handleSubmit(values) {
    return this.props.dispatch(sendSms(values, this.props.resource, 'policies'));
  }

  handleOpen() {
    const { dispatch, reset } = this.props;
    dispatch(reset());
    dispatch(openModal(FORM_NAME));
  }

  render() {
    const { label, handleSubmit, submitting } = this.props;
    const title = label || 'Send SMS';
    const submitButton = (
      <Button type="submit" bsStyle="primary" isLoading={submitting} label="Send SMS" />
    );

    return (
      <div className="pull-right">
        <Button
          bsStyle="primary"
          label={title}
          rightIcon="mobile"
          handleClick={::this.handleOpen}
        />

        <Modal
          name={FORM_NAME}
          title={title}
          close={true}
          handleSubmit={handleSubmit(::this.handleSubmit)}
          footer={submitButton}
        >
          <div className="form-horizontal">
            <div className="col-xs-12">
              <Field
                name={'meta.sms_number'}
                label="Phone number"
                labelSize={3}
                component={HorizontalFormControl}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const form = reduxForm({ form: FORM_NAME, validate })(SendSmsButton);

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      meta: {
        send_sms: true,
        sms_number: props.phoneNumber,
      },
    },
  };
};

export default connect(mapStateToProps)(form);
